export default {
    listagem: {
        titulo_pagina: 'Lista de Escala',
        novo: 'Crear Nueva Escala',
        habilitado: 'Capaz',
        desabilitado: 'Desactivado',
        table: {
            empty: 'No se encontró escala',
            nome: 'Nombre',
            codigo: 'Código',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nueva Escala',
            editar: 'Editar Escala'
        },
        fields: {
            codigo: {
                label: 'Código',
                description: 'Código de Escala'
            },
            nome: {
                label: 'Nombre',
                description: 'Nombre de Escala'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo de la escala'
            },
            botao_salvar : 'Guardar Escala'
        },
        create: {
            success: '¡Escala creada con éxito!',
            error: '¡Error al crear la escala!'
        },
        update: {
            success: '¡Escala editada con éxito!',
            error: '¡Error al editar la escala!'
        }
    }
}
